import Axios from "axios";
import Apis from "../../config/Apis";
import {
  hideLoading,
  showLoading,
  showAlert,
  getTypes,
} from "../Actions/GeneralActions";
import { headers } from "../../utills";

import Storage from "../../utills/AsyncStorage";
import {
  isLogin,
  getUser,
  changeThemeColor,
  changeThemeFont,
  isLogout,
} from "../Actions/AuthAction";

export const AuthMiddleware = {
  GeneralType: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(Apis.getAllTypes);
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getTypes(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "GeneralType",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  login: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("password", userdata?.password);
          formdata.append("role", userdata?.role);
          formdata.append("device_id", userdata?.deviceID);
          const data = await Axios.post(Apis.login, formdata);
          if (data?.status == 200) {
            const encodedData = JSON.parse(atob(data?.data?.data));
            Storage.setToken(encodedData?.token);
            localStorage.setItem("@user", data?.data?.data)
            // Storage.setUser("@user", JSON.stringify(encodedData));
            Storage.setERole("@role", JSON.stringify(encodedData?.role));
            Storage.setRole("role", JSON.stringify(encodedData?.role));
            dispatch(getUser(encodedData));
            dispatch(isLogin(true));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  Sociallogin: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("first_name", userdata?.given_name);
          formdata.append("last_name", userdata?.family_name);
          // formdata.append("device_id", userdata?.deviceID);
          formdata.append("role", userdata?.role);
          const data = await Axios.post(Apis.social_login, formdata);
          if (data?.status == 200) {
            const encodedData = data?.data?.data;
            Storage.setToken(encodedData?.token);
            Storage.setUser("@user", JSON.stringify(encodedData));
            Storage.setERole("@role", JSON.stringify(encodedData?.role));
            Storage.setRole("role", JSON.stringify(encodedData?.role));
            dispatch(getUser(encodedData));
            dispatch(isLogin(true));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Sociallogin",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Internal error",
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getUserData: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getUserData,
            await headers.config()
          );
          if (data?.status == 200) {
            const encodedData = JSON.parse(atob(data?.data?.data));
            localStorage.setItem("@user", data?.data?.data)
            // Storage.setUser("@user", JSON.stringify(encodedData));
            dispatch(getUser(encodedData));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  onChangeNotification: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.updateNotificationSetting,
            await headers.config()
          );
          if (data?.status == 200) {
            Storage.setUser("@user", JSON.stringify(data?.data?.data));
            dispatch(getUser(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  signUp: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("first_name", userdata.first_name);
          formdata.append("last_name", userdata.last_name);
          formdata.append("email", userdata.email);
          formdata.append("contact_no", userdata.contact_no);
          formdata.append("password", userdata.password);
          formdata.append("confirm_password", userdata.confirm_password);
          formdata.append("role", userdata.role);
          if (userdata.dob) formdata.append("dob", userdata.dob);
          if (userdata.gender) formdata.append("gender", userdata.gender);
          if (userdata.vendor_type)
            formdata.append("vendor_type", userdata.vendor_type);
          if (userdata.company_name)
            formdata.append("company_name", userdata.company_name);
          if (userdata.experience)
            formdata.append("experience", userdata.experience);
          if (userdata.service_id)
            formdata.append("service_id", userdata.service_id);
          if (userdata.company_image)
            formdata.append("company_image", userdata.company_image);

          const data = await Axios.post(Apis.signup, formdata);

          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "signup",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "signUp",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateClientProfile: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("first_name", userdata.first_name);
          formdata.append("last_name", userdata.last_name);
          formdata.append("email", userdata.email);
          formdata.append("contact_no", userdata.contact_no);
          if (userdata.image) formdata.append("image", userdata.image);
          if (userdata.dob) formdata.append("dob", userdata.dob);
          if (userdata.gender) formdata.append("gender", userdata.gender);
          if (userdata.address) formdata.append("address", userdata.address);
          if (userdata.lat) formdata.append("lat", userdata.lat);
          if (userdata.lng) formdata.append("lng", userdata.lng);

          const data = await Axios.post(
            Apis.updateClientProfile,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            await Storage.set("@user", JSON.stringify(data?.data?.data));
            dispatch(getUser(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "updateClientProfile",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "updateClientProfile",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateVendorProfile: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (userdata.first_name)
            formdata.append("first_name", userdata.first_name);
          if (userdata.last_name)
            formdata.append("last_name", userdata.last_name);
          if (userdata.email) formdata.append("email", userdata.email);
          if (userdata.contact_no)
            formdata.append("contact_no", userdata.contact_no);
          if (userdata.image) formdata.append("image", userdata.image);
          if (userdata.dob) formdata.append("dob", userdata.dob);
          if (userdata.gender) formdata.append("gender", userdata.gender);
          if (userdata.address) formdata.append("address", userdata.address);
          if (userdata.lat) formdata.append("lat", userdata.lat);
          if (userdata.lng) formdata.append("lng", userdata.lng);
          if (userdata.socialLinks?.length > 0) {
            for (const [index, item] of userdata?.socialLinks.entries()) {
              formdata.append(`sociallinks[${index}][platform]`, item.platform);
              formdata.append(`sociallinks[${index}][link]`, item.link);
            }
          }
          // Business Information
          if (userdata?.comp_name)
            formdata.append("comp_name", userdata.comp_name);
          if (userdata?.comp_contact_no)
            formdata.append("comp_contact_no", userdata.comp_contact_no);
          if (userdata?.description)
            formdata.append("description", userdata.description);
          if (userdata?.start_time)
            formdata.append("start_time", userdata.start_time);
          if (userdata?.end_time)
            formdata.append("end_time", userdata.end_time);
          if (userdata?.service_price)
            formdata.append("service_price", userdata.service_price);
          if (userdata?.service_category)
            formdata.append("service_category_id", userdata.service_category);
          if (userdata?.service_offer)
            formdata.append("service_offer", userdata.service_offer);
          if (userdata?.schedule_type)
            formdata.append("schedule_type", userdata.schedule_type);
          if (userdata.availablity?.length > 0) {
            for (const [index, item] of userdata?.availablity.entries()) {
              formdata.append(`days[${index}][day]`, item.day);
            }
          }

          // if (userdata.images?.length > 0) {
          //   for (const [index, item] of userdata?.images.entries()) {
          //     if (item?.id) {
          //       formdata.append(`images[${index}][id]`, item?.id);
          //     } else {
          //       formdata.append(`images[${index}][image]`, item?.image);
          //     }
          //   }
          // }
          if (userdata.images) {
            if (userdata.images.length > 0) {
              for (const [index, item] of userdata.images.entries()) {
                if (item?.id) {
                  formdata.append(`images[${index}][id]`, item.id);
                } else {
                  formdata.append(`images[${index}][image]`, item.image || item);
                }
              }
            } else {
              formdata.append("images", JSON.stringify([]));
            }
          }

          // if (userdata.documents?.length > 0) {
          //   for (const [index, item] of userdata?.documents.entries()) {
          //     if (item?.id) {
          //       formdata.append(`documents[${index}][id]`, item?.id);
          //     } else {
          //       formdata.append(`documents[${index}][doc]`, item?.doc);
          //     }
          //   }
          // }

          if (userdata.documents) {
            if (userdata.documents.length > 0) {
              for (const [index, item] of userdata.documents.entries()) {
                if (item?.id) {
                  formdata.append(`documents[${index}][id]`, item.id);
                } else {
                  formdata.append(`documents[${index}][doc]`, item.doc || item);
                }
              }
            } else {
              formdata.append("documents", JSON.stringify([]));
            }
          }

          const data = await Axios.post(
            Apis.updateVendorProfile,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            Storage.setUser("@user", JSON.stringify(data?.data?.data));
            dispatch(getUser(data?.data?.data));
            resolve(true);
            if (!userdata?.messageHide)
              dispatch(
                showAlert({
                  title: "updateVendorProfile",
                  message: data?.data?.message,
                  type: "Success",
                  status: data?.status,
                })
              );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "updateVendorProfile",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getAds: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getAllAdvertisements,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
        }
      });
    };
  },

  logout: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(Apis.logout, await headers.config());
          if (data) {
            resolve(true);
          }
        } catch (error) {
          if (error.message == "Request failed with status code 401") {
            resolve(true);
          } else {
            reject(error);
          }
        } finally {
          dispatch(hideLoading());
          resolve(true);
          Storage.clearStorage();
          dispatch(isLogout());
        }
      });
    };
  },

  forgetPassword: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          const data = await Axios.post(Apis.forgotPassword, formdata);
          if (data?.status == 200) {
            resolve(data?.data);
          }
        } catch (error) {
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            })
          );
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  verifyCode: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", userdata?.id);
          formdata.append("code", userdata?.code);
          const data = await Axios.post(Apis.verifyCode, formdata);
          if (data?.status == 200) {
            resolve(data?.data);
            dispatch(
              showAlert({
                message: data?.data?.message,
                type: "Success",
              })
            );
          }
        } catch (error) {
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            })
          );
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  changePassword: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("token", userdata?.token);
          formdata.append("email", userdata?.email);
          formdata.append("password", userdata?.newPassword);
          formdata.append("confirm_password", userdata?.confirmPassword);
          const data = await Axios.post(Apis.changePassword, formdata);
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Change password",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updatePassword: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("old_password", userdata?.currentPassword);
          formdata.append("new_password", userdata?.newPassword);
          formdata.append("confirm_password", userdata?.confirmPassword);
          const data = await Axios.post(
            Apis.updatePassword,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Update password",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Update password",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  contactUs: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("query_title", userdata?.query_title);
          formdata.append("message", userdata?.message);
          const data = await Axios.post(
            Apis.contactUs,
            formdata,
            await headers.config()
          );

          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "contactUs",
                message: data?.data?.message,
                type: "Success",
                status: 200,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "contactUs",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  UpdateRole: ({ user_id, role }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("user_id", user_id);
          formdata.append("role", role);

          const data = await Axios.post(
            Apis.updateRole,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data);
            dispatch(
              showAlert({
                title: "UpdateRole",
                message: data?.data?.message,
                type: "Success",
                status: 200,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "UpdateRole",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  // /Muneeeb code:
  Login: (userData) => {
    return (dispatch) => {
      // dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          // let formdata = new FormData();
          // formdata.append("email", userData?.email);
          // formdata.append("password", userData?.password);
          // // formdata.append('device_id', userData?.DeviceToken);
          // formdata.append("role", userData?.role);
          // const { data } = await Axios.post(Apis.login, formdata);
          // if (data?.success) {
          localStorage.setItem("token", "data?.data?.token");
          localStorage.setItem("@user", "JSON.stringify(data?.data)");
          localStorage.setItem("role", userData);
          dispatch(getUser({ name: "michel" }));
          dispatch(isLogin(true));
          // dispatch(
          //   isLogin({ isLogin: true, userData: { name: "michel" } })
          // );
          //   dispatch(hideLoading());
          // } else {
          //   dispatch(hideLoading());
          //   dispatch(
          //     showAlert({ type: "error", message: data?.message })
          //   );
          // }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "Error", message: "Network error" }));
          dispatch(hideLoading());
        }
      });
    };
  },

  LoginUpdateStatus: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("is_online", userData?.status);
          const { data } = await Axios.post(Apis.updateOnlineStatus, formdata, {
            headers: headers.config(),
          });
          if (data?.success) {
            localStorage.setItem("@user", JSON.stringify(userData?.user));
            dispatch(getUser(userData?.user));
          }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "Error", message: "Network error" }));
        }
      });
    };
  },

  SignUp: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("first_name", userData?.First_Name);
          formdata.append("last_name", userData?.Last_Name);
          formdata.append("email", userData?.email);
          formdata.append("password", userData?.password);
          formdata.append("confirm_password", userData?.Confirm_Password);
          // formdata.append('device_id', userData?.DeviceToken);
          const { data } = await Axios.post(Apis.signup, formdata);
          if (data?.success) {
            resolve(data);
            dispatch(hideLoading());
            dispatch(showAlert({ type: "Success", message: data?.message }));
          } else {
            dispatch(hideLoading());
            dispatch(showAlert({ type: "Error", message: data?.message }));
          }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "Error", message: "Network error" }));
          dispatch(hideLoading());
        }
      });
    };
  },

  getUserInfo: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.get(Apis.getUserInfo, {
            headers: headers.config(),
          });
          if (data?.success) {
            localStorage.setItem("@user", JSON.stringify(data?.data));
            dispatch(getUser(data?.data));
          } else {
            dispatch(showAlert({ type: "Error", message: data?.message }));
          }
        } catch (error) {
          reject(error);
        }
      });
    };
  },

  UpdateProfile: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();

          if (userData?.pickImage) {
            formdata.append("profile_image", userData?.pickImage);
          }
          formdata.append("first_name", userData?.Firstname);
          formdata.append("last_name", userData?.Lastname);
          formdata.append("contact_no", userData?.ContactNumber);
          for (const [i, document] of userData?.MultipleAddress.entries()) {
            if (document?.street) {
              formdata.append(`addresses[${i}][street]`, document?.street);
            } else {
              formdata.append(`addresses[${i}][street]`, null);
            }
            if (document?.state) {
              formdata.append(`addresses[${i}][state]`, document?.state);
            } else {
              formdata.append(`addresses[${i}][state]`, null);
            }
            if (document?.zipcode) {
              formdata.append(`addresses[${i}][zipcode]`, document?.zipcode);
            } else {
              formdata.append(`addresses[${i}][zipcode]`, null);
            }
            if (document?.id) {
              formdata.append(`addresses[${i}][address_id]`, document?.id);
            }
          }
          formdata.append("category_id", userData?.selectedCategory);
          // userData?.StartTime
          //   ? formdata.append("working_start_time", userData?.StartTime)
          //   : formdata.append("working_start_time", null);
          // userData?.EndTime
          //   ? formdata.append("working_end_time", userData?.EndTime)
          //   : formdata.append("working_end_time", null);
          // formdata.append('profile_image', null);

          const { data } = await Axios.post(Apis.updateProfile, formdata, {
            headers: headers.config(),
          });
          if (data?.success) {
            resolve(data);
            localStorage.setItem("@user", JSON.stringify(data?.data));
            dispatch(getUser(data?.data));
            dispatch(hideLoading());
          } else {
            dispatch(hideLoading());
            dispatch(showAlert({ type: "Success", message: data?.message }));
            // Alert.alert('Note', data?.message);
          }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "Warning", message: "Network Error" }));
          // alert('Network Error');
          dispatch(hideLoading());
        }
      });
    };
  },

  ForgotPassword: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userData?.email);
          const { data } = await Axios.post(Apis.forgotPassword, formdata);
          if (data?.success) {
            resolve(data);
            dispatch(hideLoading());
            dispatch(showAlert({ type: "Success", message: data?.message }));
          } else {
            dispatch(hideLoading());
            // Alert.alert('Note', data?.message);
            dispatch(showAlert({ type: "Warning", message: data?.message }));
          }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "Warning", message: "Network error" }));
          dispatch(hideLoading());
        }
      });
    };
  },

  ConfirmPassword: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userData?.Email);
          formdata.append("password", userData?.Password);
          formdata.append("confirm_password", userData?.ConfirmPassword);

          const { data } = await Axios.post(Apis.change_password, formdata);
          if (data?.success) {
            resolve(data);
            dispatch(hideLoading());
          } else {
            dispatch(hideLoading());
            // Alert.alert('Note', data?.message);
            dispatch(showAlert({ type: "warning", message: data?.message }));
          }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "warning", message: "Network Error" }));
          dispatch(hideLoading());
        }
      });
    };
  },

  updatePassword: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("old_password", userData?.old_password);
          formdata.append("new_password", userData?.new_password);
          formdata.append("confirm_password", userData?.confirm_password);

          const { data } = await Axios.post(
            Apis.updatePassword,
            formdata,
            await headers.config()
          );
          if (data?.success) {
            resolve(data);
            dispatch(hideLoading());
            dispatch(showAlert({ type: "Success", message: data?.message }));
          } else {
            dispatch(hideLoading());
            dispatch(showAlert({ type: "Warning", message: data?.message }));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              type: "Error",
              message: error?.response?.data?.message,
            })
          );
          dispatch(hideLoading());
        }
      });
    };
  },

  Logout: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(Apis.logout, await headers.config());
          if (data?.status == 200) {
            resolve(true);
            dispatch(getUser(null));
            dispatch(isLogin(false));
            dispatch(changeThemeColor("#ED73AA"));
            dispatch(changeThemeFont("'Poppins', sans-serif"));

            resolve(true);
            localStorage.clear();
          }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "Error", message: "Network error" }));
          dispatch(hideLoading());
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  DeleteAccount: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.post(
            Apis.deleteAccount,
            {},
            {
              headers: headers.config(),
            }
          );
          if (data?.success) {
            await localStorage.clearStorage();
            dispatch(getUser(null));
            dispatch(isLogin(false));
            dispatch(hideLoading());
          } else {
            dispatch(hideLoading());
            dispatch(showAlert({ type: "warning", message: data?.message }));
            // Alert.alert('Note', data?.message);
          }
        } catch (error) {
          reject(error);
          dispatch(showAlert({ type: "warning", message: "Network error" }));
          // alert('Network error');
          dispatch(hideLoading());
        }
      });
    };
  },
  // /Muneeeb code:
};
